module.exports = "pegasus/assets/circleline-linkedin.png";